import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { EpicCard } from "./EpicCard";
import { Epic, Project, User, UserRole } from "../../types";

interface SortableEpicCardProps {
    epic: Epic;
    selectedId: string | null;
    onSelect: (id: string) => void;
    getPreviousScore: (id: string) => number | undefined | null;
    getProjectName?: (id?: string) => string;
    projects?: Project[];
    onUpdate?: (id: string, updates: Partial<Epic>) => void;
    users?: User[];
    userRole?: UserRole;
}

export function SortableEpicCard({
    epic,
    selectedId,
    onSelect,
    getPreviousScore,
    getProjectName,
    projects,
    onUpdate,
    users,
    userRole
}: SortableEpicCardProps) {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({ id: epic.id, data: { epic } });

    const style = {
        transform: transform ? CSS.Transform.toString(transform) : undefined,
        transition,
    };

    return (
        <div ref={setNodeRef} style={style} {...attributes} {...listeners} className="group touch-none">
            <EpicCard
                epic={epic}
                onClick={() => onSelect(epic.id)}
                selected={epic.id === selectedId}
                previousScore={getPreviousScore(epic.id)}
                projectName={getProjectName?.(epic.projectId)}
                dragging={isDragging}
                projects={projects}
                onUpdate={onUpdate}
                users={users}
                userRole={userRole}
            />
        </div>
    );
}

export default SortableEpicCard;
